import { Box, ColorOptions, ModBox, Spacer, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../../components/AdminButton'
import { useIsFocused, useNavigation } from '@react-navigation/core'
import { useCallback, useEffect, useState } from 'react'
import { EmType } from '..'
import { VerticalStepIndicator } from '../../../components/VerticalStepIndicator'
import { useLazyApiData, useStores } from '../../../data/store'
import { isAccessible } from '../../../utils'
import { FullScreenLoader } from '../../EntityOnboarding/OnboardEntity/comps/FullScreenLoader'
import { BusinessDetails } from '../Onboarding/BusinessDetails'
import { CreateEntity } from '../Onboarding/CreateEntity'
import { StatusComp } from '../Onboarding/CreationStatus/StatusComp'
import { Documentation } from '../Onboarding/Documentation'
import { styles } from '../styles'

const Header = ({ currentStep, groupName }: any) => {
  return (
    <Box {...styles.header}>
      <Text title={'Create Sub-Group'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
      <ModBox show={currentStep > 1} direction={'row'} marginLeft={24}>
        <Box backgroundColor={'#F0F0F0' as ColorOptions} borderRadius={2} padding={4} direction={'row'}>
          <Text title={'Group: '} color={'BLACK_75'} fontSize={12} fontFamily={'jiotype-medium'} />
          <Text title={groupName ?? 'NA'} color={'BLACK_21'} fontSize={12} fontFamily={'jiotype-bold'} />
        </Box>
      </ModBox>
    </Box>
  )
}

const Footer = ({
  show,
  currentStep,
  setCurrentStep,
  setIsReset,
  setCreateEntityValid,
  createEntityValid,
  isBusinessDataValid,
  isDocumentationValid,
  isLoading,
}: any) => {
  const titles: any = {
    1: 'Proceed To Business Details',
    2: 'Proceed To Documentation',
    3: 'Submit',
  }
  const handleFooterPress = () => {
    setCurrentStep(currentStep + 1)
  }
  const onCancelOnboarding = () => {
    setCurrentStep(1)
    setIsReset(true)
    setCreateEntityValid(false)
  }

  const isValid: any = {
    1: createEntityValid,
    2: isBusinessDataValid,
    3: isDocumentationValid,
  }

  if (!show) {
    return null
  }
  return (
    <Box {...styles.footerNonEntity}>
      <ButtonNew
        hide={currentStep < 2}
        type={'secondary'}
        borderWidth={1}
        height={40}
        title={'Cancel Onboarding'}
        borderColor={'PRIMARY'}
        onPress={onCancelOnboarding}
      />
      <Spacer size={32} direction={'horizontal'} />
      <ButtonNew
        onPress={handleFooterPress}
        title={titles[currentStep]}
        height={40}
        width={230}
        isLoading={isLoading}
        disabled={!isValid[currentStep]}
      />
    </Box>
  )
}

const CreateSubGroup = () => {
  const { groupName, resetDataEntered, fetchAllLovs, clearDocuments, accessConfig, createSubGroup, getSubGroupData } =
    useStores((store) => ({
      groupName: store.onboarding.group.groupName,
      resetDataEntered: store.onboarding.resetDataEntered,
      fetchAllLovs: store.fetchAllLovs,
      clearDocuments: store.clearDocuments,
      accessConfig: store.user.getAccessConfig(['entity_management_service', 'sub_group']),
      createSubGroup: store.createSubGroup,
      getSubGroupData: store.onboarding.getSubGroupData,
    }))
  const steps = ['Select Parent', 'Business Details', 'Documentation']
  const [currentStep, setCurrentStep] = useState(1)
  const [isBusinessDataValid, setBusinessdataValid] = useState(false)
  const [createEntityValid, setCreateEntityValid] = useState(false)
  const [isReset, setIsReset] = useState(false)
  const [isDocumentationValid, setDocumentationValid] = useState(false)
  const [createEmsSubGroup, createSubGrpHandler] = useLazyApiData(createSubGroup)

  const isFocused = useIsFocused()
  const navigation = useNavigation()

  useEffect(() => {
    fetchAllLovs(...['DocumentType', 'DocumentName'])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setCurrentStep(isFocused ? 1 : -1)
    resetDataEntered()
    clearDocuments()
  }, [isFocused])

  useEffect(() => {
    if (createSubGrpHandler.state === 'fulfilled') {
      setCurrentStep(4)
    }
  }, [createSubGrpHandler?.state])

  const getBusinessDataValidity = (values: any, isValid: boolean) => {
    setBusinessdataValid(isValid)
  }

  const isCreateEntityValidToProceed = (isValid: boolean) => {
    if (isValid) {
      setCreateEntityValid(isValid)
    }
  }

  const isDocumentationValidToProceed = (isValid: boolean) => {
    setDocumentationValid(isValid)
  }
  console.log('createSubGrpHandler', createSubGrpHandler)

  const onNavigateToSubGroup = useCallback(() => {
    try {
      resetDataEntered()
      clearDocuments()
    } catch (e) {
      console.log('e', e)
    }
    navigation.reset({
      index: 0,
      routes: [{ name: 'createEntitySubGroup' }],
    })
  }, [])

  const getScreen: any = {
    1: <CreateEntity type={EmType.createSubGroup} isValidToProceed={isCreateEntityValidToProceed} isReset={isReset} />,
    2: (
      <BusinessDetails
        type={EmType.createSubGroup}
        isValidToProceed={getBusinessDataValidity}
        isEditMode={createSubGrpHandler.state !== 'fulfilled'}
      />
    ),
    3: (
      <Documentation
        type={EmType.createSubGroup}
        isValidToProceed={isDocumentationValidToProceed}
        selectedEntity={undefined}
      />
    ),
  }

  const onStepPressed = (stepPressed: number) => {
    console.log('stepPressed', stepPressed)
    setCurrentStep(stepPressed)
  }
  const onSavePressed = (step) => {
    console.log('stepPressed', step)
    if (step !== 4) {
      setCurrentStep(step)
    } else {
      const createSubGrpData = getSubGroupData()
      createEmsSubGroup(createSubGrpData)
    }
  }
  const onNavigateToMyQueue = useCallback(() => navigation.navigate('makerMyQueue'), [navigation])

  return (
    <ModBox {...styles.container} show={isAccessible(accessConfig, 'create')}>
      {createSubGrpHandler?.state === 'fulfilled' && (
        <StatusComp
          type={EmType.createSubGroup}
          isCreateSuccess={true}
          onBackPress={undefined}
          applicationId={createSubGrpHandler.data?.data?.applicationId}
          isUserCreationPressed={false}
          navigateToCreateGroup={onNavigateToSubGroup}
          showSuccess={true}
          navigateToMyAppQueue={onNavigateToMyQueue}
          businessName={undefined}
        />
      )}
      <Header currentStep={currentStep} groupName={groupName} />
      <Box flexDirection={'row'} f={1}>
        <Box w={220}>
          <VerticalStepIndicator currentStep={currentStep} steps={steps} onStepPressed={onStepPressed} />
        </Box>
        <Box flexGrow={1} f={1} overflow={'auto'} testID="vertical-scroll">
          {getScreen[currentStep]}
        </Box>
      </Box>
      <Footer
        show={currentStep <= 3}
        currentStep={currentStep}
        setCurrentStep={onSavePressed}
        setIsReset={setIsReset}
        setCreateEntityValid={setCreateEntityValid}
        createEntityValid={createEntityValid}
        isBusinessDataValid={isBusinessDataValid}
        isDocumentationValid={isDocumentationValid}
        isLoading={createSubGrpHandler.state === 'pending'}
      />
      <FullScreenLoader show={createSubGrpHandler?.state === 'pending'} />
    </ModBox>
  )
}
export default CreateSubGroup
